import { Card, Typography, Space } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import './Home.css';

const { Title, Paragraph } = Typography;

export const Home = () => {
    return (
        <div className="home-page">
            <Card className="welcome-card">
                <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
                    <RocketOutlined style={{ fontSize: 64, color: '#1890ff' }} />
                    <Title level={1}>Welcome to Cloudflare ATMB</Title>
                    <Paragraph style={{ fontSize: 16 }}>
                        A modern full-stack template built with Cloudflare Workers, Hono, React, and Ant Design.
                    </Paragraph>
                    <Paragraph type="secondary">
                        Start building your next project with this production-ready template.
                    </Paragraph>
                </Space>
            </Card>
        </div>
    );
};
